import { render, staticRenderFns } from "./PlansPrevention.vue?vue&type=template&id=253842e0&"
import script from "./PlansPrevention.vue?vue&type=script&lang=ts&"
export * from "./PlansPrevention.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports